module.exports = __webpack_public_path__ + "img/programme9.211af509.png";